import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DrugClassesData, MedicineIngredientsData } from '@models/medicine.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MedpraxService {
  constructor(private readonly http: HttpClient) {}

  getMedicineIngredients$(): Observable<MedicineIngredientsData[]> {
    return this.http.get<MedicineIngredientsData[]>('/api/medprax/medicine/ingredients');
  }

  getDrugClasses$(): Observable<DrugClassesData[]> {
    return this.http.get<DrugClassesData[]>('/api/medprax/medicine/drug_classes');
  }
}
